import Model, { attr, belongsTo, hasMany } from '@ember-data/model';

import type GroupModel from 'later/models/group';
import type MetaAdUserModel from 'later/models/meta-ad-user';

export default class MetaAdAccountModel extends Model {
  @attr('string') declare uid: string;
  @attr('string') declare name: string;
  @attr('string') declare businessPortfolioName?: string;
  @attr('number') declare accountStatus: number;
  @attr('string') declare accountStatusLabel: string;
  @attr('date') declare createdTime: Date;
  @attr('date') declare accountStatusUpdatedTime: Date;
  @attr('date') declare disconnectedTime?: Date;
  // POJO attr (not a belongsTo) — backend serializes a self-contained object
  // alongside the ad account. Avoids pushing partial User records into the
  // store that would conflict with the auth-loaded current User.
  @attr() declare owningUser?: { id: string; name: string | null; email: string };

  @belongsTo('meta-ad-user', { async: false, inverse: 'metaAdAccounts' }) declare metaAdUser: MetaAdUserModel;
  // Backend serializes the assigned-group set as `group_ids: [...]`.
  // Ember Data's AMS adapter parses that as a hasMany payload — declare the
  // relationship here so it binds to the Group records already in the store
  // (loaded via auth.groups). inverse: null because Group.metaAdAccounts is
  // an independent embedded relationship, not tied to this one.
  @hasMany('group', { async: false, inverse: null }) declare groups: GroupModel[];
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'meta-ad-account': MetaAdAccountModel;
  }
}
